import './DataTableBody.css';
export var body = '_51sfnf0-3-8-0';
export var loading = '_51sfnf1-3-8-0';